import React, { Component } from "react";
import { Link } from "react-router-dom";

import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Divider from "material-ui/Divider";

import ContactInfo from "./ContactInfo";

class Footer extends Component {
  render() {
    const fullYear = new Date().getFullYear();

    return (
      <footer>
        <Grid container spacing={8} justify="center">
          <Grid item xs={12} sm={4} md={3} lg={2}>
            <Typography component="h3" align="center" variant="subheading">
              Kontaktirajte nas
            </Typography>
            <Divider light />
            <ContactInfo itemAlign="center" />
          </Grid>

          <Grid item xs={12} sm={4} md={3} lg={2} align="center">
            <Typography component="h3" align="center" variant="subheading">
              Pratite nas
            </Typography>
            <Divider light />
            <a
              href="https://www.facebook.com/PoliklinikaSente/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                <title>Posetite nas na Facebook-u</title>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      className="facebookLogo"
                      d="M25.76,46.32h6.74V30H37l.6-5.62h-5.1V21.56c0-1.47.14-2.25,2.24-2.25h2.81V13.68h-4.5c-5.41,0-7.31,2.73-7.31,7.32v3.38H22.4V30h3.37ZM30,60A30,30,0,1,1,60,30,30,30,0,0,1,30,60Z"
                      fill="#757575"
                    />
                  </g>
                </g>
              </svg>
            </a>
          </Grid>

          <Grid item xs={12} sm={4} md={3} lg={2}>
            <Typography component="h3" align="center" variant="subheading">
              Navigacija
            </Typography>
            <Divider light />
            <nav>
              <Link
                to="/kontakt"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <Button>Kontakt</Button>
              </Link>
              {/* <Link
                to="/cenovnik"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <Button>Cenovnik</Button>
              </Link> */}
              <Link
                to="/galerija"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <Button>Galerija</Button>
              </Link>
              <Link
                to="/aparati"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <Button>Aparati</Button>
              </Link>
              <Link
                to="/usluge"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <Button>Usluge</Button>
              </Link>
              <Link
                to="/doktori"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <Button>Doktori</Button>
              </Link>
              <Link
                to="/"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <Button>Poliklinika Sente</Button>
              </Link>
            </nav>
          </Grid>
          <Grid item xs={12}>
            <Typography component="h3" align="center" variant="body2">
              © {fullYear} Poliklinika Sente
            </Typography>
          </Grid>
        </Grid>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js